/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromotionCampaignFilters } from './PromotionCampaignFilters';
import {
    PromotionCampaignFiltersFromJSON,
    PromotionCampaignFiltersFromJSONTyped,
    PromotionCampaignFiltersToJSON,
} from './PromotionCampaignFilters';
import type { RedemptionLimitFrequency } from './RedemptionLimitFrequency';
import {
    RedemptionLimitFrequencyFromJSON,
    RedemptionLimitFrequencyFromJSONTyped,
    RedemptionLimitFrequencyToJSON,
} from './RedemptionLimitFrequency';
import type { PromotionCampaignTrigger } from './PromotionCampaignTrigger';
import {
    PromotionCampaignTriggerFromJSON,
    PromotionCampaignTriggerFromJSONTyped,
    PromotionCampaignTriggerToJSON,
} from './PromotionCampaignTrigger';
import type { PromotionCampaignAward } from './PromotionCampaignAward';
import {
    PromotionCampaignAwardFromJSON,
    PromotionCampaignAwardFromJSONTyped,
    PromotionCampaignAwardToJSON,
} from './PromotionCampaignAward';

/**
 * Back-office request type for creating a new promotion campaign.
 * Mirrors GDS PromotionCampaignCreateRequest but uses string for date fields —
 * the controller converts these to timezone-aware Date objects before proxying to GDS.
 * @export
 * @interface BackOfficePromotionCampaignCreateRequest
 */
export interface BackOfficePromotionCampaignCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof BackOfficePromotionCampaignCreateRequest
     */
    priority: number | null;
    /**
     * 
     * @type {PromotionCampaignAward}
     * @memberof BackOfficePromotionCampaignCreateRequest
     */
    awardConfig: PromotionCampaignAward;
    /**
     * Calendar-based frequency limit for reward redemption (e.g., max 2 per day, or lifetime with EVER)
     * @type {RedemptionLimitFrequency}
     * @memberof BackOfficePromotionCampaignCreateRequest
     */
    redemptionLimitFrequency?: RedemptionLimitFrequency | null;
    /**
     * 
     * @type {PromotionCampaignFilters}
     * @memberof BackOfficePromotionCampaignCreateRequest
     */
    filters?: PromotionCampaignFilters | null;
    /**
     * 
     * @type {number}
     * @memberof BackOfficePromotionCampaignCreateRequest
     */
    triggerCount: number;
    /**
     * 
     * @type {PromotionCampaignTrigger}
     * @memberof BackOfficePromotionCampaignCreateRequest
     */
    trigger: PromotionCampaignTrigger;
    /**
     * 
     * @type {string}
     * @memberof BackOfficePromotionCampaignCreateRequest
     */
    endAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackOfficePromotionCampaignCreateRequest
     */
    startAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackOfficePromotionCampaignCreateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackOfficePromotionCampaignCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BackOfficePromotionCampaignCreateRequest
     */
    id?: string;
}



/**
 * Check if a given object implements the BackOfficePromotionCampaignCreateRequest interface.
 */
export function instanceOfBackOfficePromotionCampaignCreateRequest(value: object): value is BackOfficePromotionCampaignCreateRequest {
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('awardConfig' in value) || value['awardConfig'] === undefined) return false;
    if (!('triggerCount' in value) || value['triggerCount'] === undefined) return false;
    if (!('trigger' in value) || value['trigger'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function BackOfficePromotionCampaignCreateRequestFromJSON(json: any): BackOfficePromotionCampaignCreateRequest {
    return BackOfficePromotionCampaignCreateRequestFromJSONTyped(json, false);
}

export function BackOfficePromotionCampaignCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackOfficePromotionCampaignCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'priority': json['priority'],
        'awardConfig': PromotionCampaignAwardFromJSON(json['awardConfig']),
        'redemptionLimitFrequency': json['redemptionLimitFrequency'] == null ? undefined : RedemptionLimitFrequencyFromJSON(json['redemptionLimitFrequency']),
        'filters': json['filters'] == null ? undefined : PromotionCampaignFiltersFromJSON(json['filters']),
        'triggerCount': json['triggerCount'],
        'trigger': PromotionCampaignTriggerFromJSON(json['trigger']),
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'description': json['description'] == null ? undefined : json['description'],
        'name': json['name'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function BackOfficePromotionCampaignCreateRequestToJSON(value?: BackOfficePromotionCampaignCreateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'priority': value['priority'],
        'awardConfig': PromotionCampaignAwardToJSON(value['awardConfig']),
        'redemptionLimitFrequency': RedemptionLimitFrequencyToJSON(value['redemptionLimitFrequency']),
        'filters': PromotionCampaignFiltersToJSON(value['filters']),
        'triggerCount': value['triggerCount'],
        'trigger': PromotionCampaignTriggerToJSON(value['trigger']),
        'endAt': value['endAt'],
        'startAt': value['startAt'],
        'description': value['description'],
        'name': value['name'],
        'id': value['id'],
    };
}

